import { Component, OnInit } from '@angular/core';
import { SiteApiService } from '@services';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormSchemaModel, Snackbar, TagModel } from '@models';
import { Helper } from '@helpers';
import { StyleAppHelper } from 'app/providers/style-app-helper';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
})
export class FormComponent implements OnInit {
    public leadForm: FormSchemaModel;
    public slug: string;
    public token: string;
    public snackbar: Snackbar = new Snackbar();
    public sendOk: boolean = false;
    public thanksHtmlText: string;
    public colors: any = {};
    public logoUrl: string | ArrayBuffer;
    public error: any;
    public feedback: boolean = false;

    constructor(
        private siteApiService: SiteApiService,
        private styleAppHelper: StyleAppHelper,
        private router: Router,
        private route: ActivatedRoute,
        private helper: Helper
    ) {
        this.siteApiService.getAppSettings().subscribe(
            (response) => {
                response.forEach((setting: any) => {
                    if (setting.setting_type === 'colour') {
                        this.colors[setting.key] = setting.value;
                    }
                    if (
                        setting.setting_type === 'image' &&
                        setting.key === 'logo'
                    ) {
                        if (setting.associated_image) {
                            // retrieve logo if exists
                            this.siteApiService
                                .getImage(setting.associated_image)
                                .subscribe(
                                    async (response) => {
                                        this.logoUrl =
                                            await this.helper.createImageFromBlob(
                                                response
                                            );
                                    },
                                    (error) => {
                                        console.log(error);
                                    }
                                );
                        }
                    }
                });
                this.styleAppHelper.setCSSVars(this.colors);
                this.styleAppHelper.defineAlphaScale(
                    this.colors['ow-color-primary'],
                    this.colors['ow-color-white']
                );
            },
            (error) => {
                console.log(error);
            }
        );
    }

    ngOnInit(): void {
        this.slug = this.route.snapshot.params.slug;
        this.token = this.route.snapshot.params.token;

        if (!this.isNotFoudPage(this.slug)) {
            this.siteApiService.getPages(this.slug, this.token).subscribe(
                (response: FormSchemaModel) => {
                    const form = response;
                    let background = null;
                    if (response.background) {
                        background = response.background.toString();
                    }
                    if (background) {
                        // retrieve background if exists
                        this.siteApiService.getImage(background).subscribe(
                            async (blob) => {
                                form.background =
                                    await this.helper.createImageFromBlob(blob);
                                this.leadForm = form;
                            },
                            (error) => {
                                console.log(error);
                                // load form without bg
                                this.leadForm = form;
                                this.snackbar.error();
                                this.snackbar.text = `ERROR: ${error.status} when trying to load the background.`;
                                this.snackbar.autoClose = false;
                                this.feedback = true;
                                this.snackbar.activate();
                            }
                        );
                    } else {
                        this.leadForm = response;
                        if (
                            this.leadForm.title != null ||
                            this.leadForm.text != null
                        ) {
                            this.leadForm.text =
                                this.helper.replaceTemplateTags(
                                    this.leadForm.text,
                                    <TagModel[]>this.leadForm.tags
                                );
                        }
                    }
                },
                (error: any) => {
                    if (
                        error.status == 404 ||
                        error.error.message === 'Page not exists'
                    ) {
                        this.router.navigate(['/404']);
                    } else {
                        this.error = error;
                    }
                }
            );
        } else {
            this.router.navigate(['/404']);
        }
    }

    isNotFoudPage(slug: string): boolean {
        return slug === '404';
    }

    activateSnackbarWithDelay(delay: number = 100): void {
        this.feedback = true;
        setTimeout(() => {
            this.snackbar.activate();
        }, delay);
    }

    sendForm(obj: Object): void {
        this.siteApiService
            .postPages(this.slug, obj['schema']['form'], this.token)
            .subscribe(
                (response) => {
                    this.snackbar.success();
                    this.snackbar.text = 'Enviado correctamente';
                    this.activateSnackbarWithDelay();
                    this.sendOk = true;
                    this.thanksHtmlText = response['thanks_message'];
                },
                (error) => {
                    console.log(error);
                    if (error.error.key === 'USERNAME_ALREADY_EXISTS') {
                        this.snackbar.error();
                        this.snackbar.text = 'El usuario ya existe.';
                        this.activateSnackbarWithDelay();
                    } else {
                        this.snackbar.error();
                        this.snackbar.text = error.error.message;
                        this.activateSnackbarWithDelay();
                    }
                }
            );
    }
}
